import { ApiProperty } from "@nestjs/swagger";
import { GrnItemsForReturn } from "./grn-item-details-for-return.dto";

export class GrnDetailsForReturn {
    @ApiProperty()
    grnId: number;
    @ApiProperty()
    vendorId: number;
    @ApiProperty()
    vendorName: string;
    @ApiProperty()
    grnReturnDate: Date;
    @ApiProperty()
    grnReturnNumber?: string;
    @ApiProperty()
    grnDate: Date;
    @ApiProperty()
    invoiceDate: Date;
    @ApiProperty()
    invoiceNumber: string;
    @ApiProperty()
    grnNumber: string;
    @ApiProperty()
    totalCost: number;
    @ApiProperty()
    remarks: string;
    @ApiProperty()
    grnItems: GrnItemsForReturn[];
    @ApiProperty()
    createdUser: string;
    @ApiProperty()
    plantId: number;
}